import React from 'react';
import { BALL_COLORS, PROGRESS_BAR_COLORS } from '../../constants';
import classes from './BallGrid.module.scss';

const BallGrid = ({
  title,
  maxValue,
  selectedValues,
  minCount,
  maxCount,
  onToggle,
  ballColor,
  disabledValues = [],
  showHeader = true,
}) => {
  const balls = Array.from({ length: maxValue }, (_, i) => i + 1);
  const currentCount = selectedValues.length;
  const isFull = currentCount >= maxCount;
  const isExact = minCount === maxCount;
  const isValid =
    (isExact && currentCount === maxCount) ||
    (!isExact && currentCount >= minCount && currentCount <= maxCount);
  const progressColor = isValid ? PROGRESS_BAR_COLORS.VALID : PROGRESS_BAR_COLORS.INVALID;
  const progressPct = Math.min((currentCount / maxCount) * 100, 100);

  return (
    <>
      {showHeader && (
        <div className={classes.Header}>
          <div className={classes.HeaderText}>
            <h4 className={classes.Title}>{title}</h4>
            <p className={classes.Subtitle}>
              {isExact
                ? `Pick ${maxCount} number${maxCount > 1 ? 's' : ''}`
                : `Pick ${minCount} - ${maxCount} numbers`}
            </p>
          </div>

          <div className={classes.ProgressContainer}>
            <div className={classes.ProgressTrack}>
              <div
                className={classes.ProgressBar}
                style={{ width: `${progressPct}%`, backgroundColor: progressColor }}
              />
            </div>
            <span className={classes.Count} style={{ color: progressColor }}>
              {currentCount} / {maxCount}
            </span>
          </div>
        </div>
      )}

      <div className={classes.Grid}>
        {balls.map((value) => {
          const isSelected = selectedValues.includes(value);
          const isDisabledByConstraint = disabledValues.includes(value);
          const isDisabledByCount = !isSelected && isFull;
          const isDisabled = isDisabledByConstraint || isDisabledByCount;

          return (
            <button
              key={value}
              type="button"
              onClick={() => !isDisabled && onToggle(value)}
              disabled={isDisabled}
              className={
                classes.BallButton
                + (isSelected ? ' ' + classes.Selected : '')
                + (isDisabled && !isSelected ? ' ' + classes.Disabled : '')
              }
              style={
                isSelected
                  ? { background: ballColor, color: BALL_COLORS.TEXT, borderColor: 'transparent' }
                  : { color: BALL_COLORS.NORMAL }
              }
            >
              <span className={classes.BallText}>{value}</span>
            </button>
          );
        })}
      </div>
    </>
  );
};

export default BallGrid;
